// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"414":"b94369d2","878":"ac39732e"}[chunkId] + ".chunk.js";
};